import type { ProvinceDTO } from "../../../api/contract";
import {
  ADE_DEFAULT_JOB_RATE_REQ_PER_MIN,
  ADE_ESTIMATE_YEARS_FULL,
  ADE_REQS_PER_ZONE_YEAR,
} from "../../../api/scrape-config";
import type { GeocodeHit } from "../../api";
import { Btn, Card } from "../../ui";
import type { LookupEstimate } from "./estimate";

interface EstimateCardProps {
  selected: GeocodeHit;
  province: ProvinceDTO | null;
  estimate: LookupEstimate | null;
  onCopyCoordinates: () => void;
}

export function EstimateCard({
  selected,
  province,
  estimate,
  onCopyCoordinates,
}: EstimateCardProps) {
  return (
    <Card
      title="Stima scrape AdE"
      sub={
        province
          ? `provincia ${province.code} · ${province.comuni} comuni · ${province.estOMI} zone OMI`
          : "provincia non mappata"
      }
    >
      {!province ? (
        <div style={{ color: "var(--text-2)", fontSize: 13 }}>
          Provincia{" "}
          <strong>
            {selected.address?.provinceCode || selected.address?.province || "?"}
          </strong>{" "}
          non configurata nel DB.
        </div>
      ) : (
        estimate && (
          <div className="col gap-10">
            <div className="preview-est">
              <div className="cell">
                <div className="k">Indirizzo</div>
                <div className="v">~{estimate.secSingle.toFixed(1)}s</div>
              </div>
              <div className="cell">
                <div className="k">Zona OMI · 10y</div>
                <div className="v">~{Math.round(estimate.secZone10y)}s</div>
              </div>
              <div className="cell">
                <div className="k">Comune medio · 10y</div>
                <div className="v">~{estimate.minComune.toFixed(1)} min</div>
              </div>
              <div className="cell">
                <div className="k">Provincia · 10y</div>
                <div className="v">~{estimate.hoursProvince.toFixed(1)} h</div>
              </div>
            </div>
            <div className="muted" style={{ fontSize: 11 }}>
              Stima conservativa: rate {ADE_DEFAULT_JOB_RATE_REQ_PER_MIN} req/min ·{" "}
              {ADE_REQS_PER_ZONE_YEAR} req per zona-anno · range{" "}
              {ADE_ESTIMATE_YEARS_FULL} anni
              <br />
              Richieste totali provincia:{" "}
              <strong>{estimate.reqsProvince.toLocaleString()}</strong>
            </div>
            <div className="row gap-8">
              <Btn variant="ghost" onClick={() => onCopyCoordinates()}>
                Copia coords
              </Btn>
            </div>
          </div>
        )
      )}
    </Card>
  );
}
